/**
 * Builds a stub for a native-only function. Calling it throws, so web callers
 * fail the same way they would if the native module were missing.
 */
export const unavailableOnWeb = (name) => (..._args) => {
    throw new Error(`${name} is not available on web`);
};
